import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaFileMedical, FaShieldAlt, FaChartBar, FaUsers, FaClock, FaUserCheck, FaHeartbeat, FaChartLine, FaLaptopMedical, FaBrain, FaClipboardCheck, FaNetworkWired, FaStethoscope, FaNotesMedical, FaHandHoldingMedical, FaMoneyBillWave } from "react-icons/fa";
import Medpalm from "../../../assests/Healthsoftware/cmr.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Role-Based Alerts & Notifications",
        "description": "Automated, real-time notifications that alert healthcare providers about critical conditions, abnormal lab results, drug interactions, and overdue screenings. These alerts help clinicians take immediate action, reducing the risk of adverse events. For example, a physician is notified if a patient with diabetes has not had an A1C test in the past six months. The system ensures compliance with clinical guidelines, reduces medical errors, and enhances patient safety by providing timely interventions."
    },
    {
        "title": "Risk Assessment Tools",
        "description": "Advanced tools that use clinical and historical data to assess patient risk levels and predict health outcomes."
    },
    {
        "title": "Case Management Systems",
        "description": "Systems designed to improve the management of at-risk patient populations, enabling healthcare organizations to coordinate care more effectively."
    },
    {
        "title": "Clinical Workflow Integration",
        "description": "Seamlessly integrate CDS tools into existing clinical workflows to enhance care quality and operational efficiency."
    },
    {
        "title": "Patient Monitoring Solutions",
        "description": "Remote monitoring systems that track patient health metrics in real time, integrating with CDS for timely intervention and care adjustments."
    },
    // {
    //     "title": "Population Health Management",
    //     "description": "A comprehensive data-driven approach to identifying and managing at-risk patient populations. By aggregating electronic health records (EHRs), claims data, and social determinants of health, this system helps healthcare organizations track chronic disease trends, improve preventive care, and optimize resource allocation. For example, it can identify patients with high readmission risks and enroll them in targeted intervention programs. This supports value-based care models, reduces healthcare costs, and enhances community health outcomes."
    // }
]

const features = [
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Integrates patient data to provide real-time risk assessments, allowing healthcare providers to identify and address potential health threats before they escalate." },
    { icon: <FaChartBar className="text-[#2a627a] text-lg" />, text: "Use predictive analytics to anticipate patient health declines, enabling early intervention and improved patient management." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Our CDS solutions integrate smoothly with your existing clinical, electronic health records (EHR), and health management systems to enhance workflow and reduce inefficiencies." },
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Generate automated alerts based on patient risk factors, offering actionable recommendations to healthcare providers to guide care decisions." },
    { icon: <FaNetworkWired className="text-[#2a627a] text-lg" />, text: "Provides detailed reports on patient risk trends, outcomes, and interventions, supporting continuous improvement in case management practices." },
    // { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "Personalized treatment recommendations based on patient history." }
];

const benefits = [
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "By providing healthcare providers with the right data at the right time, CDS improves patient care through timely, informed decision-making." },
    { icon: <FaClock className="text-[#2a627a] text-lg" />, text: "Helps identify high-risk patients early, enabling prompt interventions that can prevent complications and reduce healthcare costs." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Streamlines communication between healthcare providers, ensuring that all relevant data is available for collaborative decision-making." },
    { icon: <FaHandHoldingMedical className="text-[#2a627a] text-lg" />, text: "Automates routine tasks, reduces administrative burdens, and allows healthcare professionals to focus on patient care instead of paperwork." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Ensure compliance with healthcare regulations, such as HIPAA, by maintaining secure data management and reporting protocols within the CDS system." },
    // { icon: <FaMoneyBillWave className="text-[#2a627a] text-lg" />, text: "Lowers healthcare costs by minimizing errors and redundant treatments." }
];
const cmsFeatures = [
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Healthcare Provider (Physician) – Utilizes the CDS to assess risk factors and provide timely interventions to mitigate patient risks, improving care delivery and patient safety." },
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Clinical Decision Support Specialist – Designs and implements CDS systems that enhance clinical decision-making, ensuring providers have access to timely, relevant data." },
    { icon: <FaBrain className="text-[#2a627a] text-lg" />, text: "Data Scientist – Uses analytics to interpret large datasets and develop predictive models that identify high-risk patients and suggest proactive care pathways." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Case Manager – Integrates CDS tools to effectively monitor and manage at-risk patients, coordinating care to reduce hospitalization and improve health outcomes." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Health IT Specialist – Develops and maintains the infrastructure that supports the integration of CDS tools into existing healthcare systems, ensuring data security and system interoperability" },
    // { icon: <FaUsers className="text-[#2a627a] text-lg" />, text: "CDS Trainer – Educates healthcare providers on using CDS tools effectively." }
];
const CDS = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  flex justify-center items-center"><span className="text-gray-800">Risk/Case Management</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Enhance medical decision-making with AI-driven insights, evidence-based recommendations, and real-time alerts."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Risk/Case Management (CDS)?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Risk/Case Management involves the identification, assessment, and management of patient risks through clinical decision support systems (CDS). These systems use data from various healthcare sources to identify high-risk patients and provide timely interventions. By integrating CDS into your clinical workflow, healthcare organizations can improve diagnostic accuracy, optimize care, and prevent adverse outcomes.
                        </p>
                    </div>
                </section>

                {/* Role in Telemedicine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Risk/Case Management
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <span className="text-sm">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <span className="text-sm">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                <span className="text-sm">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default CDS;
